import { FileListItem } from "@/components/IBFile/interface";

export const fileUploadLoadingMaxPercent: number = 90;

export const fileUploadProgress = (fileItem: FileListItem) => (progressEvent: any) => {
	const loaded = progressEvent?.loaded || 0;
	const total = progressEvent?.total || 0;

	fileItem.loadingPercent = Math.min(fileUploadLoadingMaxPercent, loaded * 100 / total);
};

export const fileUploadEnd = <T = any>(fileItem: FileListItem) => (response: T) => {
	fileItem.loadingPercent = 100;

	return response;
};